import axios from "axios"
import { useState } from "react"
import queryString from 'query-string'
import { get_property_reports_traffic } from "../../api/api"

const FilterReportPublishDate = ({ queries, setData, active, mode }) => {

    const [isLoading, setIsLoading] = useState(false)

    const handleOnClick = async (e) => {
        try {
            setData({})
            setIsLoading(true)
            const res = await axios.get(get_property_reports_traffic(queryString.stringify(queries), 0, active))
            setData({ type: 2, data: { publishDate: res.data }, mode: mode })
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <>
            <button
                disabled={isLoading}
                className={`moreFiltersButton ${active?.publishDate ? 'active' : ''} ${mode ? 'chartModeBtn' : ''}`}
                type="button"
                onClick={handleOnClick}>{isLoading ? '...' : 'سال انتشار'}
                {!isLoading && active?.publishDate ? ': ' + active.publishDate?.name : ''}
            </button>
        </>
    );
}

export default FilterReportPublishDate;